import React, { useState, useEffect } from "react";
import ModalComponent from "../../Components/Modal/Modal";
import { useToggle } from "../../Hook";
import { handleLogErrorToSlack } from "../../Helper";
import axios from "axios";
import { notify } from "react-notify-toast";
import uuid from "uuid/v4";
import "./Resume.css";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import {
  updateQualification,
  updateVetTrainingQualification,
  updateVetIndustryQualification,
} from "../../redux/homePage/homePage.actions";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { API } from "../../API";
import { Fragment } from "react";

function QualificationModal(props) {
  const {
    updateQualification,
    updateVetTrainingQualification,
    updateVetIndustryQualification,
  } = props;

  const [user, setUser] = useState();
  const [isCreate, toggleCreate] = useToggle(props.isCreate);
  const [startDate, setStartDate] = useState(
    props.content.start_date
      ? Date.parse(
          `${props.content.start_date.substring(
            0,
            2
          )}/01/${props.content.start_date.substring(3, 7)}`
        )
      : new Date()
  );
  const [graduationDate, setGraduationDate] = useState(
    props.content.graduation_date && props.content.graduation_date !== "Present"
      ? Date.parse(
          `${props.content.graduation_date.substring(
            0,
            2
          )}/01/${props.content.graduation_date.substring(3, 7)}`
        )
      : new Date()
  );
  const [gradQDatePickerVisible, toggleQGradDatePicker] = useToggle(
    props.content.graduation_date !== "Present"
  );

  const [qualification_fileName, setQualification_fileName] = useState(null);
  const qualification = isCreate
    ? null
    : props.user.qualifications.filter((q) => q._id === props.qualificationID);

    let [link, setLink] = useState(
    props.content ? props.content.qualification_url : ""
  );
  let [fName, setFName] = useState(
    props.content ? props.content.certificate_filename : ""
  );
  let [transcript_link, settranscript_Link] = useState(
    props.content ? props.content.transcript_url : ""
  );
  let [transcript_fName, settranscript_FName] = useState(
    props.content ? props.content.transcript_filename : ""
  );
  let [enrolment_link, setenrolment_Link] = useState(
    props.content ? props.content.enrolment_url : ""
  );
  let [enrolment_fName, setenrolment_FName] = useState(
    props.content ? props.content.enrolment_filename : ""
  );

  const [isSubmit, setIsSubmit] = useState(false)

  const deleteTranscript = (e) => {
    settranscript_Link(null);
    settranscript_FName(null);
  };

  const deleteCertificate = (e) => {
    setLink(null);
    setFName(null);
  };

  const deleteEnrolment = (e) => {
    setenrolment_Link(null);
    setenrolment_FName(null);
  };
  const handleClose = () => {
    if (!isSubmit) {
      props.showPopup(false);
    }
    props.resetFile()
  };
  const prepareValue = (id, linkUploaded) => {
    const institution_name = document
      .querySelector("#institution")
      .value.trim();
    const degree = document.querySelector("#degree").value;
    const major = document.querySelector("#major").value;
    const award_name = document.querySelector("#award_name").value;
    const start_date = document.querySelector("#start_date").value;
    const qualification_url = linkUploaded;
    const transcript_url = transcript_link;
    const enrolment_url = enrolment_link;
    const certificate_filename = fName;
    const transcript_filename = transcript_fName;
    const enrolment_filename = enrolment_fName;
    const institution_website = document.querySelector("#institution-website")
      .value;
    const verification_status = false;
    const graduation_date = document.querySelector("#current_date").checked
      ? "Present"
      : document.querySelector("#graduation_date").value;
    const institution_location = document
      .querySelector("#institution-location")
      .value.trim();
    const newQualification = {
      institution_name: institution_name,
      degree: degree,
      major: major,
      qualification_url: qualification_url,
      qualification_status: false,
      transcript_url: transcript_url,
      enrolment_url: enrolment_url,
      transcript_status: false,
      certificate_filename: certificate_filename,
      transcript_filename: transcript_filename,
      enrolment_filename: enrolment_filename,
      institution_website: institution_website,
      institution_location: institution_location,
      award_name: award_name,
      start_date: start_date,
      graduation_date: graduation_date,
      verification_status: verification_status,
      _id: id,
      // description: description
    };
    return newQualification;
  };

  const sendEmailNotification = (tpenIndx, emailType) => {
    API.sendTeacherProfileProgressEmail({
      _id: props.user._id,
      to: props.user.email,
      first_name: props.user.first_name,
      etype: emailType,
    }).then((result) => {
        console.log("result:", result);
      })
      .catch((err) => {
        console.log("err:", err);
      });
  };

  const prepareCommonQualInfo = (isVet, linkUploaded) => {
    const degree = isVet ? document?.querySelector("#degree")?.value : '';
    const award_name = document.querySelector("#award_name")?.value;
    let course_code, major;
    if (isVet) {
      course_code = document.querySelector("#course_code")?.value;
    } else {
      major = document.querySelector("#major").value;
    }
    const institution_name = document
      .querySelector("#institution")
      .value.trim();
    const institution_location = document
      .querySelector("#institution-location")
      .value.trim();
    const institution_website = document.querySelector("#institution-website")
      .value;
    const start_date = document.querySelector("#start_date").value;
    const graduation_date = document.querySelector("#current_date").checked
      ? "Present"
      : document.querySelector("#graduation_date").value;

    const qual_data = {
      degree,
      award_name,
      major,
      institution_name,
      institution_location,
      institution_website,
      start_date,
      graduation_date,
      qualification_url: linkUploaded,
      certificate_filename: fName,
      qualification_status: false,
      transcript_url: transcript_link,
      transcript_filename: transcript_fName,
      transcript_status: false,
      enrolment_url: enrolment_link,
      enrolment_filename: enrolment_fName,
      verification_status: false,
    };

    if (isVet) {
      qual_data.course_code = course_code;
    } else {
      qual_data.major = major;
    }

    return qual_data;
  };

  const prepareVetQualification = (id, linkUploaded) => {
    const commonInfo = prepareCommonQualInfo(true, linkUploaded);

    const newTrainingQual = {
      ...commonInfo,
      _id: id,
    };

    return newTrainingQual;
  };

  const submitVetQualification = async (event, dispatchAction) => {
    let updateType = "";
    event.preventDefault();
    setIsSubmit(true)

    let linkUploaded = ""
    try {
      linkUploaded = props.isUploadDrive ? await handleUploadGoogleDriveFile() : await handleUploadFile()
    } catch (error) {
      console.log('error', error)
    }

    if (!linkUploaded) {
      props.showPopup(false);
      props.resetFile()
      return
    }

    const id = uuid();

    const newQualification = prepareVetQualification(id, linkUploaded);
    const content_id = props.content._id;
    const valid = checkFiles(newQualification, true);

    if (valid) {
      props.showPopup(false);

      sendEmailNotification(6, "QUAL_CONF");

      if (props.content !== "" && content_id) {
        updateType = "EDIT";
        dispatchAction({ newQualification, updateType, content_id });
      } else {
        updateType = "ADD";
        dispatchAction({ newQualification, updateType });
      }
    }
    props.resetFile()
  };

  const submitVetTrainingQual = (event) => {
    submitVetQualification(event, updateVetTrainingQualification);
  };

  const submitVetIndustryQual = (event) => {
    submitVetQualification(event, updateVetIndustryQualification);
  };

  const handleSave = async (event) => {
    let updateType = "";
    event.preventDefault();

    setIsSubmit(true)
    let linkUploaded = ""
    try {
      linkUploaded = props.isUploadDrive ? await handleUploadGoogleDriveFile() : await handleUploadFile()
    } catch (error) {
      console.log('error', error)
    }

    if (!linkUploaded) {
      props.showPopup(false);
      props.resetFile()
      setIsSubmit(false)
      return
    }

    const id = uuid();
    // ======= Prepare values =======
    const newQualification = prepareValue(id, linkUploaded);
    const content_id = props.content._id;
    const valid = checkFiles(newQualification);
    if (valid) {
      // ======= Close popup =======
      props.showPopup(false);

      // Email notification
      sendEmailNotification(6, "QUAL_CONF");

      // ======= Update user  =======
      //   const newUser = Object.assign({}, props.user);
      if (props.content !== "" && content_id) {
        updateType = "EDIT";
        updateQualification({ newQualification, updateType, content_id });
      } else {
        updateType = "ADD";
        updateQualification({ newQualification, updateType });
      }
    }
    props.resetFile()
    setIsSubmit(false)
  };

  const handleUploadGoogleDriveFile = async () => {
    try {
      props.toggleLoading(true)
      const response = await API.uploadGoogleDriveFileToS3(props.fileFromDrive);
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;
      setLink(new_url);
      props.toggleLoading(false)

    } catch (error) {
      props.toggleLoading(false)
      notify.show("Error when upload file. Please try again later")
      console.log(`⚡️[log]: †††††† ~ error: `, error);
      handleLogErrorToSlack(error);
    }
  };

  const handleUploadFile = async () => {
    const file = props.file

    if (file) {
      try {
        props.toggleLoading(true)

        const [preFileName, fileType] = file.name.split(".");
        const fileName = preFileName
          .replace(/[^\w.]/gi, "")

        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", `qualification_${fileName}`)
        const response = await API.uploadCompressedFileToS3(formData)

        const url = response?.data?.data
        const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
        const suffix = url.substring(cut_length, url.length);
        const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
        const new_url = prefix + suffix;
        setLink(new_url);
        props.toggleLoading(false)

        notify.show('File upload successfully');
        return new_url
      } catch (error) {
        props.toggleLoading(false)
        notify.show("File cannot uploaded. Please choose another file.")
        handleLogErrorToSlack(error, true);
        console.log(error);
      }
    }
  }

  const checkFiles = (newQualification, isVet) => {
    let isvalid = true;
    if (document.getElementById("qualification-date-file").getAttribute('hidden')) {
      return isvalid
    }
    if (!document.querySelector("#current_date").checked) {
      if (
        newQualification.certificate_filename === "" ||
        newQualification.certificate_filename === null
      ) {
        notify.show("Please upload your certificate");
        isvalid = false;
      } else if (
        !isVet &&
        (newQualification.transcript_filename === "" ||
          newQualification.transcript_filename === null)
      ) {
        notify.show("Please upload your transcript");
        isvalid = false;
      } else {
        isvalid = true;
      }
    } else if (
      newQualification.enrolment_filename === "" ||
      newQualification.enrolment_filename === null
    ) {
      notify.show("Please upload your statement of Enrolment");
      isvalid = false;
    }
    return isvalid;
  };

  //When select a degree in qualification form, change happen
  const changeforselectELTdegree = (e) => {
    if (
      e.target.value === "Cambridge CELTA" ||
      e.target.value === "Cambridge DELTA" ||
      e.target.value === "Trinity TESOL"
    ) {
      document.getElementById("award_name").setAttribute("disabled", true);
      document.getElementById("award_name").setAttribute("placeholder", "");
      document.getElementById("award_name").value = "";
      document.getElementById("major").setAttribute("disabled", true);
      document.getElementById("major").setAttribute("placeholder", "");
      document.getElementById("major").value = "";
    } else {
      document.getElementById("award_name").removeAttribute("disabled");
      document.getElementById("major").removeAttribute("disabled");
      // console.log(
      //   document.getElementById("award_name").getAttribute("disabled")
      // );
    }
  };

  const changeforselectVETdegree = (e) => {
    if (e.target.value === "No VET Training Qualification") {
      document.getElementById("institution-info").setAttribute("hidden", true);
      document.getElementById("qualification-date-file").setAttribute("hidden", true);
      document.getElementById("institution").removeAttribute("required");
      document.getElementById("institution-location").removeAttribute("required");
      document.getElementById("institution-website").removeAttribute("required");
    } else {
      document.getElementById("institution-info").removeAttribute("hidden");
      document.getElementById("qualification-date-file").removeAttribute("hidden");
      document.getElementById("institution").setAttribute("required", true);
      document.getElementById("institution-location").setAttribute("required", true);
      document.getElementById("institution-website").setAttribute("required", true);
    }
  };

  const uploadDocument = (id) => {
    document.getElementById(id).click();
  };

  const uploadFileToServer = (e, fileNamePrefix, uploadingCompleted) => {
    const file = e.target.files[0];
    // console.log(file)
    const filesize = e.target.files[0].size >> 10;

    if (file) {
      const [preFileName, fileType] = e.target.files[0].name.split(".");
      const fileName = preFileName
        .replace(/[^\w.]/gi, "")
        .replace(/  +/g, "");

      API.uploadFileToS3({
        fileName: `${fileNamePrefix}${fileName}`,
        fileType: fileType,
        _id: props.user._id,
      })
        .then((res) => {
          const returnData = res.data.data.returnData;
          const signedRequest = returnData.signedRequest;
          const url = returnData.url;
          const options = {
            headers: {
              "Content-Type": fileType,
            },
          };
          axios
            .put(signedRequest, file, options)
            .then((res2) => {
              const newUser = Object.assign({}, props.user);
              const cut_length = "https://platform-backend-files.s3.amazonaws.com/"
                .length;
              const suffix = url.substring(cut_length, url.length);
              const prefix =
                // "https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?path=";
                "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path="; 
              const new_url = prefix + suffix;
              const urlSplittedArray = url.split(
                `${props.user._id}/${fileNamePrefix}`
              );

              uploadingCompleted(newUser, new_url, fileName, urlSplittedArray);
            })
            .catch((error1) => {
              handleLogErrorToSlack(error1, true)
              console.log(error1);
            });
        })
        .catch((err) => {
          alert(JSON.stringify(err));
        });
    } else {
      console.log("Upload Error");
    }
  };

  const updateQualificationForUser = (newUser, newUrl, fileName) => {
    newUser.qualification_url = newUrl;
    newUser.qualification_filename = fileName;
  };

  const qualificatonUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    updateQualificationForUser(newUser, newUrl, fileName);

    setQualification_fileName(fileName);
    setLink(newUrl);
    setFName(urlSplittedArray[1]);
  };

  const handleSaveQualificationFile = (e) => {
    uploadFileToServer(e, "qualification", qualificatonUploadingCompleted);
  };

  const transcriptUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    updateQualificationForUser(newUser, newUrl, fileName);

    setQualification_fileName(fileName);
    settranscript_Link(newUrl);
    settranscript_FName(urlSplittedArray[1]);
  };

  const handleSaveTranscriptFile = (e) => {
    uploadFileToServer(
      e,
      "qualification/transcript",
      transcriptUploadingCompleted
    );
  };

  const enrolmentUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    newUser.enrolment_url = newUrl;
    newUser.enrolment_filename = fileName;

    setQualification_fileName(fileName);
    setenrolment_Link(newUrl);
    setenrolment_FName(urlSplittedArray[1]);
  };

  const handleSaveEnrolmentFile = (e) => {
    uploadFileToServer(
      e,
      "qualification/enrolment",
      enrolmentUploadingCompleted
    );
  };

  const buildCommonQualificationContent = (isVet, isVetTraining) => {
    const eltAwardTypes = [
      <option value="PhD in">PhD</option>,
      <option value="Master of/in">Master’s Degree</option>,
      <option value="Bachelor of">Bachelor’s Degree</option>,
      <option value="Graduate Diploma of/in">Graduate Diploma</option>,
      <option value="Graduate Certificate in">Graduate Certificate</option>,
      <option value="Advanced Diploma of/in">Advanced Diploma</option>,
      <option value="Diploma of/in">Diploma</option>,
      <option value="Certificate IV in">Certificate IV</option>,
      <option value="Certificate III in">Certificate III</option>,
      <option value="Certificate II in">Certificate II</option>,
      <option value="Certificate I in">Certificate I</option>,
      <option value="Cambridge CELTA">Cambridge CELTA</option>,
      <option value="Cambridge DELTA"> Cambridge DELTA</option>,
      <option value="Trinity TESOL"> Trinity TESOL</option>,
    ];

    const vetAwardTypes = [
        <option value="PhD in">PhD</option>,
        <option value="Master of/in">Master’s Degree</option>,
        <option value="Bachelor of">Bachelor’s Degree</option>,
        <option value="Graduate Diploma of/in">Graduate Diploma</option>,
        <option value="Graduate Certificate in">Graduate Certificate</option>,
        <option value="Advanced Diploma of/in">Advanced Diploma</option>,
        <option value="Diploma of/in">Diploma</option>,
        <option value="Certificate IV in">Certificate IV</option>,
        <option value="Certificate III in">Certificate III</option>,
        <option value="Certificate II in">Certificate II</option>,
        <option value="Certificate I in">Certificate I</option>,
        <option value="Cambridge CELTA">Cambridge CELTA</option>,
        <option value="Cambridge DELTA"> Cambridge DELTA</option>,
        <option value="Trinity TESOL"> Trinity TESOL</option>,
    ];

    const vetTrainingAwardTypes = [
      <option value="TAE40122 Certificate IV in Training and Assessment">
        TAE40122 Certificate IV in Training and Assessment
      </option>,
      <option value="TAE40116 Certificate IV in Training and Assessment">
        TAE40116 Certificate IV in Training and Assessment
      </option>,
      <option value="TAE40110 Certificate IV in Training and Assessment">
        TAE40110 Certificate IV in Training and Assessment plus the following units:
        TAELLN411 (or its successor) or TAELLN401A,
        and TAEASS502 (or its successor) or TAEASS502A or TAEASS502B
      </option>,
      <option value="Diploma or higher level qualification in adult education">
        A diploma or higher level qualification in adult education
      </option>,
      <option value="No VET Training Qualification">
        I do not currently hold nor am I currently undertaking any of the above qualifications and can
        therefore deliver non-accredited courses only
      </option>
    ]

    return (
      <Fragment>
        <div className="row">
          <div className="col-md-6">
            <FormDropdown
              label={isVetTraining ? "Select Training Qualification" : "Award Type"}
              name="degree"
              id="degree"
              required
              defaultValue={props.content ? props.content.degree : ""}
              onChange={isVet ? changeforselectVETdegree : changeforselectELTdegree}
              noMargin
            >
              <option value="" hidden>
                Please Select
              </option>
              {isVet ? (isVetTraining ? vetTrainingAwardTypes : vetAwardTypes) : eltAwardTypes}
            </FormDropdown>

            {isVetTraining ? null :
              <FormField
                label="Award Title"
                name="award_name"
                id="award_name"
                // placeholder="Applied Linguistics"
                required
                header={
                  <HoverIcon
                    icon="info circle"
                    color="grey"
                    text="Field of Study only. Do not include the words Master, Bachelor. Diploma or Certificate."
                  />
                }
                defaultValue={
                  props.content
                    ? props.content.award_name
                    : qualification
                    ? qualification[0].major
                    : ""
                }
                noMargin
              />}

            {isVetTraining ? null : isVet ? (
              <FormField
                label="Course Code"
                placeholder="TAE40116"
                name="course_code"
                id="course_code"
                defaultValue={
                  props.content
                    ? props.content.course_code
                    : qualification
                    ? qualification[0].details
                    : ""
                }
                noMargin
              />
            ) : (
              <FormField
                label="Major/s"
                placeholder="Separate majors with comma"
                name="major"
                id="major"
                defaultValue={
                  props.content
                    ? props.content.major
                    : qualification
                    ? qualification[0].details
                    : ""
                }
                noMargin
              />
            )}

            <div id='institution-info'>
              <FormField
                label="Institution Name"
                name="institution"
                id="institution"
                // placeholder="University of Sydney"
                required
                defaultValue={
                  props.content
                    ? props.content.institution_name
                    : qualification
                    ? qualification[0].institution_name
                    : ""
                }
                noMargin
              />

              <FormField
                label="Institution Website"
                name="institution-website"
                id="institution-website"
                // placeholder="sydney.edu.au"
                required
                defaultValue={
                  props.content ? props.content.institution_website : ""
                }
                noMargin
              />

              <FormField
                label="Institution City/Town"
                name="institution-location"
                id="institution-location"
                pattern="^[A-Za-z\s]+$"
                title="Please enter a valid City/Town"
                placeholder="Sydney"
                required
                defaultValue={
                  props.content ? props.content.institution_location : ""
                }
                noMargin
              />
            </div>
          </div>

          <div className="col-md-6" id='qualification-date-file'>
            <FormDatePicker
              label="Start Date"
              id="start_date"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={graduationDate}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              value={startDate}
              placeholderText={new Date()}
              isClearable
              maxWidth
              noMargin
              required
            />
            <CheckableButton
              checkbox
              id="current_date"
              name="current_date"
              defaultChecked={
                props.content
                  ? props.content.graduation_date === "Present"
                  : false
              }
              onChange={toggleQGradDatePicker}
              noBorder
            >
              Currently Enrolled
            </CheckableButton>

            <div id="end_date_block" hidden={!gradQDatePickerVisible}>
              <FormDatePicker
                label="Graduation Date"
                id="graduation_date"
                selected={graduationDate}
                onChange={(date) => setGraduationDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={graduationDate}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                value={graduationDate}
                minDate={startDate}
                placeholderText={new Date()}
                isClearable
                maxWidth
                required={gradQDatePickerVisible}
              />
            </div>
            {/* document upload */}

            <div className="form-group" hidden={!gradQDatePickerVisible}>
              <FormField
                label={"Upload Certificate"}
                id="certificate"
                placeholder={
                  fName
                    ? fName
                    : "Upload jpeg jpg or pdf"
                }
                disabled
                header={
                  <>
                    <HoverIcon
                      icon="lock"
                      color="grey"
                      text="Your documents will be encrypted and stored securely"
                    />
                    <HoverIcon
                      icon="info circle"
                      color="grey"
                      text="Please upload a file less than 600KB."
                    />
                  </>
                }
                sideButton={{
                  onClick: () => uploadDocument("upload_qualification"),
                  id: "Select_Button",
                  label: fName ? "Uploaded" : "Select",
                  small: true,
                  disabled: fName,
                }}
                footer={
                  fName && link ? (
                    <div className="text-left d-flex">
                      <a
                        href={`/NavigateToFileViewer?fileurl=${link}`}
                        target="_blank"
                      >
                        <p className="uploaded-file-name mt-1 ml-1">{fName}</p>
                      </a>
                      <i
                        className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                        onClick={deleteCertificate}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )
                }
              />
              <input
                type="file"
                id="upload_qualification"
                name="upload_qualification"
                onChange={handleSaveQualificationFile}
                style={{ display: "none" }}
                accept=".jpg, .pdf"
              />
            </div>

            <div className="form-group" hidden={gradQDatePickerVisible}>
              <FormField
                label="Upload Statement of Enrolment"
                id="certificate"
                placeholder={
                  enrolment_fName
                    ? enrolment_fName
                    : "No file chosen (.jpg and .pdf files supported)"
                }
                disabled
                header={
                  <>
                    <HoverIcon
                      icon="lock"
                      color="grey"
                      text="Your documents will be encrypted and stored securely"
                    />
                    <HoverIcon
                      icon="info circle"
                      color="grey"
                      text="Please upload a file less than 600KB."
                    />
                  </>
                }
                sideButton={{
                  onClick: () => uploadDocument("upload_enrolment"),
                  id: "Select_Button",
                  label: enrolment_fName ? "Uploaded" : "Select",
                  small: true,
                  disabled: enrolment_fName,
                }}
                footer={
                  enrolment_fName ? (
                    <div className="text-left d-flex">
                      <a
                        href={`/NavigateToFileViewer?fileurl=${enrolment_link}`}
                        target="_blank"
                      >
                        <p className="uploaded-file-name mt-1 ml-1">
                          {enrolment_fName}
                        </p>
                      </a>
                      <i
                        className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                        onClick={deleteEnrolment}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )
                }
              />
              <input
                type="file"
                id="upload_enrolment"
                name="upload_enrolment"
                onChange={handleSaveEnrolmentFile}
                style={{ display: "none" }}
                accept=".jpg, .pdf"
              />
            </div>

            <div className="form-group" hidden={!gradQDatePickerVisible || isVetTraining}>
              <FormField
                label="Upload Academic Transcript/Statement of Results"
                id="certificate"
                placeholder={
                  transcript_fName
                    ? transcript_fName
                    : "Upload jpeg jpg or pdf"
                }
                disabled
                header={
                  <>
                    <HoverIcon
                      icon="lock"
                      color="grey"
                      text="Your documents will be encrypted and stored securely"
                    />
                    <HoverIcon
                      icon="info circle"
                      color="grey"
                      text="Please upload a file less than 600KB."
                    />
                  </>
                }
                sideButton={{
                  onClick: () =>
                    uploadDocument("upload_qualificationTranscript"),
                  id: "Select_Button_1",
                  label: transcript_fName ? "Uploaded" : "Select",
                  small: true,
                  disabled: transcript_fName,
                }}
                footer={
                  transcript_fName ? (
                    <div className="text-left d-flex">
                      <a
                        href={`/NavigateToFileViewer?fileurl=${transcript_link}`}
                      >
                        <p className="uploaded-file-name mt-1 ml-1">
                          {transcript_fName}
                        </p>
                      </a>
                      <i
                        className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                        onClick={deleteTranscript}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )
                }
              />
              <input
                type="file"
                id="upload_qualificationTranscript"
                name="upload_qualificationTranscript"
                onChange={handleSaveTranscriptFile}
                style={{ display: "none" }}
                accept=".jpg, .pdf"
              />
            </div>

            <p className="small">
              To ensure successful verification, please upload clearly scanned
              or photographed documents.
            </p>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-md-6 mb-2 mb-md-0">
            <CancelButton type="back" value="Back" onClick={handleClose} disabled={isSubmit}>
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton type="submit" disabled={isSubmit}>Submit</ConfirmButton>
          </div>
        </div>
      </Fragment>
    );
  };

  const qualificationForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Qualification"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={handleSave}>{buildCommonQualificationContent()}</form>
        </div>
      </ModalComponent>
    );
  };

  const vetTrainingQualForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Training Qualification"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitVetTrainingQual}>
            {buildCommonQualificationContent(true, true)}
          </form>
        </div>
      </ModalComponent>
    );
  };

  const vetIndustryQualForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Industry Qualification"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitVetIndustryQual}>
            {buildCommonQualificationContent(true)}
          </form>
        </div>
      </ModalComponent>
    );
  };

  useEffect(() => {
    // Change the date picker style
    const date_picker = document.querySelectorAll(".react-datepicker-wrapper");
    if (date_picker.length !== 0) {
      for (let i = 0; i < date_picker.length; i++) {
        date_picker[i].style.display = "block";
      }
    }
  });

  return (
    <>
      {props.formType === "qualification" && qualificationForm()}
      {props.formType === "VTQ" && vetTrainingQualForm()}
      {props.formType === "VIQ" && vetIndustryQualForm()}
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateQualification: (user) => dispatch(updateQualification(user)),
  updateVetTrainingQualification: (user) =>
    dispatch(updateVetTrainingQualification(user)),
  updateVetIndustryQualification: (user) =>
    dispatch(updateVetIndustryQualification(user)),
});

export default connect(null, mapDispatchToProps)(QualificationModal);
